import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Switch from 'flarum/common/components/Switch';
app.initializers.add('ralkage/word-censor', () => {
  extend('flarum/forum/components/SettingsPage', 'privacyItems', function (items) {
    const user = this.user;
    if (!user) return;
    items.add('wordCensor', m(Switch, {
      state: user.preferences().wordCensorEnabled !== false,
      onchange: value => {
        user.savePreferences({
          wordCensorEnabled: value
        }).then(() => {
          window.location.reload();
        });
      }
    }, app.translator.trans('ralkage-word-censor.forum.settings.word_censor_label')), -10);
  });
});